import { GetAutoDeliveryCollectionApiParameter } from "@guestsupply/App/Services/AutoDelivery";
import { CustomAppState } from "@guestsupply/App/Store/Reducers";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { createContext } from "react";

export function getAutoDeliveryOrdersDataView(
    state: ApplicationState & CustomAppState,
    getAutoDeliveryOrdersApiParameter: GetAutoDeliveryCollectionApiParameter,
) {
    return getDataView(state.xAutoDelivery, getAutoDeliveryOrdersApiParameter);
}

export const AutoDeliveryPageContext = createContext<ReturnType<typeof getAutoDeliveryOrdersDataView>>({
    value: undefined,
    isLoading: false,
});
